import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";


const Status = () => {
  return (
    <SettingsMetaData propertyName={"Status_Recevable"} viewPropertyName={"Status"} />
  );
};

export default Status;
